import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Col, Grid, Icon, Typography } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import styles from 'modules/User/Security/Security.module.scss'
import GridSpinner from 'components/UI/GridSpinner'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import { INIT_2FA } from 'modules/User/Security/2fa/types'

const QrCode = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const [code, setCode] = useState(null)
  const breakpoints = useBreakpoint()

  useEffect(() => {
    setLoading(true)
    new Promise((resolve, reject) => {
      dispatch({ type: INIT_2FA, meta: { resolve, reject } })
    })
      .then((data) => {
        setCode(data)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  return (
    <>
      <Typography weight={'medium'} variant={'p4'} noMargin className={'margin-bottom-16'}>
        {t('user::security.2fa.enable_form.steps.two')}
      </Typography>

      <Grid
        gap={16}
        cols={breakpoints.sm ? 1 : 2}
        className={'margin-bottom-16'}
        direction={breakpoints.sm ? 'column' : 'row'}
      >
        <Col>
          <Button
            variant={'default'}
            fullWidth
            size={'m'}
            component={'a'}
            target={'_blank'}
            rel={'noopener noreferrer'}
            href={'https://apps.apple.com/app/google-authenticator/id388497605'}
            color={'Label-Fifth'}
            bgColor={'Background-Tertiary'}
            startIcon={<Icon name={'apple'} size={'m'} />}
          >
            {t('user::security.ios_app')}
          </Button>
        </Col>
        <Col>
          <Button
            variant={'default'}
            fullWidth
            size={'m'}
            component={'a'}
            target={'_blank'}
            rel={'noopener noreferrer'}
            href={
              'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2'
            }
            color={'Label-Fifth'}
            bgColor={'Background-Tertiary'}
            startIcon={<Icon name={'android'} size={'m'} />}
          >
            {t('user::security.android_app')}
          </Button>
        </Col>
      </Grid>

      <Typography variant={'p7'} noMargin className={'margin-bottom-40'} color={'Label-Secondary'}>
        {t('user::security.2fa.enable_form.summary')}
      </Typography>

      <Typography weight={'medium'} variant={'p4'} className={'margin-bottom-16'}>
        {t('user::security.2fa.enable_form.steps.three')}
      </Typography>

      <Typography variant={'p7'} noMargin className={'margin-bottom-16'} color={'Label-Secondary'}>
        <span dangerouslySetInnerHTML={{ __html: t('user::security.2fa.header') }} />
      </Typography>

      <Grid justifyContent={'center'}>
        {loading || !code ? (
          <GridSpinner />
        ) : (
          <img className={styles['security__block']} src={code.qr_code} alt={''} />
        )}
      </Grid>
      {code && (
        <>
          <Typography
            variant={'p7'}
            noMargin
            className={'margin-bottom-16'}
            color={'Label-Secondary'}
          >
            <span
              style={{ wordWrap: 'break-word' }}
              dangerouslySetInnerHTML={{
                __html: t('user::security.2fa.description_1', {
                  secret: code.secret,
                }),
              }}
            />
          </Typography>
          <Typography
            variant={'p7'}
            noMargin
            className={'margin-bottom-40'}
            color={'Label-Secondary'}
          >
            {t('user::security.2fa.description_2')}
          </Typography>
        </>
      )}
    </>
  )
}

QrCode.propTypes = {
  setShowDisconnectionForm: PropTypes.func,
  qr_code: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
}

export default QrCode
